import {styled} from "@mui/material/styles";
import { Card } from "@mui/material";

export const Content = styled(Card)(() => ({
    marginTop: '10px',
    padding: 20
}))
